import { useTranslation } from "react-i18next";
import { twMerge } from "tailwind-merge";
import { Button } from "@/atoms-react/button/Button.react";
import { Base } from "@/atoms-react/text/Text.react";
import { MiniAnimatedShield } from "@/components/animations/minishield/index.react";
import { CheckJoinLegalEntityResponse } from "@/features/company/types";
import { FullCountry } from "@/features/user/types";
import { Themes } from "@/types/theme";

type AddCompanyFormPrps = {
  onValidate: () => void;
  stepBack: () => void;
  countries: FullCountry[];
  company: CheckJoinLegalEntityResponse | undefined;
};
export const AddCompanyDetected = ({
  company,
  countries,
  stepBack,
  onValidate
}: AddCompanyFormPrps) => {
  const { t } = useTranslation(["pass"]);
  const getCountry = (countries: FullCountry[]) =>
    countries.find((country) => country?.alpha2.toString() === company?.homeAddress?.countryAlpha2);
  const country = (() => getCountry(countries as FullCountry[]))();

  return (
    <div>
      <div className="mt-8 flex flex-row justify-between border-2 border-slate-50 p-4 dark:border-slate-700">
        <div className="flex flex-col">
          <div>
            <Base className="mb-5 font-semibold text-base text-black">{company?.legalName}</Base>
          </div>
          <div className="flex flex-col">
            <Base>{company?.homeAddress?.address1 ?? ""}</Base>
            <div className="flex flex-row">
              <Base className="text-sm">
                {company?.homeAddress
                  ? `${company?.homeAddress?.city} ${company?.homeAddress?.zipCode}`
                  : ""}
              </Base>
            </div>
            <Base className="text-sm">{country?.name}</Base>
          </div>
        </div>
        <div className="flex w-[500px] flex-row justify-end">
          <div
            className={twMerge(
              `flex w-full flex-start justify-center rounded-sm bg-bottom bg-cover md:w-1/5 lg:px-5`,
              "h-[100px] bg-[url('/images/olkypass/declarative_kyc_bg.png')]"
            )}
          >
            <div className={"flex flex-col justify-center"}>
              {
                <MiniAnimatedShield
                  style="bottom-14 left-4 w-5 h-3"
                  colors="#D11E1F"
                  percentage={45}
                />
              }
            </div>
          </div>
        </div>
      </div>
      <div className="flex flex-row justify-center px-6 py-8">
        <Base className="text-base">{t("business.label.detection_confirmation")}</Base>
      </div>
      <div className="mt-6 flex w-full flex-row justify-between">
        <Button
          size="md"
          theme={Themes.white}
          onClick={stepBack}
          className="w-48 rounded-sm bg-primary"
        >
          {" "}
          {t("olkypass.general.go_back")}
        </Button>
        <Button size="md" onClick={() => onValidate()} className="w-48 rounded-sm bg-primary">
          {" "}
          {t("olkypass.general.confirm")}
        </Button>
      </div>
    </div>
  );
};
